import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "collapsible-pane",
  templateUrl: "./collapsible-pane.component.html",
  styleUrls: ["./collapsible-pane.component.scss"],
})
export class CollapsiblePaneComponent {
  @Input() public title: string = "Click on pane to reveal";
  @Input() public showTooltip: boolean = true;
  @Input() public backgroundDimmed: boolean;
  @Input() public disableTitleMargins: boolean;
  @Input() public hideContent: boolean = false;
  @Input() public titleBold: boolean = true;
  @Input() public collapsibleLeft: boolean = false;
  @Input() public showHeaderBtn: boolean = false;
  @Input() public showHeaderBtnText: string = "Add";
  @Input() public extraContent: string;
  @Input() public extraContentData: any;
  @Output() public contentOpened = new EventEmitter();
  @Output() public headerAction = new EventEmitter();
  @Output() public openedOrClosed = new EventEmitter();

  // for visibility function
  @Output() public changeVisibility = new EventEmitter();
  @Input() public showVisibilityIcon: boolean = false;
  @Input() public isVisible: boolean = true;
  public changingVisibility: boolean = false;

  public toggleContent() {
    if (!this.changingVisibility) {
      this.hideContent = !this.hideContent;
      if (!this.hideContent) {
        this.contentOpened.emit();
      }
      this.openedOrClosed.emit(!this.hideContent);
    }

    this.changingVisibility = false;
  }

  public headerBtnAction() {
    this.headerAction.emit();
  }

  // set hideContent to status value
  public changeStatus(status) {
    this.hideContent = status;
  }

  public toggleVisibility() {
    this.changingVisibility = true;
    this.changeVisibility.emit();
  }
}
